import {
  GET_CHAT_GROUPS,
  GET_CHAT_AGENTS,
  SEND_CHAT_ASSIGNMENT_RULES,
  GET_ALL_CHAT_ASSIGNMENT_RULES,
  UPDATE_CHAT_ASSIGNMENT_RULES,
  DELETE_CHAT_ASSIGNMENT_RULE,
  UPDATE_CHAT_ASSIGNMENT_RULE_STATUS,
} from "../constants/ChatAssignment";

import {
  saveChatAgents,
  saveChatGroups,
  saveAllChatAssignmentRules,
  getAllChatAssignmentRules as getAllChatAssignmentRulesAction,
} from "../actions/ChatAssignment";
import { all, put, takeEvery } from "redux-saga/effects";
import ApiService from "../../Services/ApiService";
import { toastNotification } from "../../utils/toastNotification";

function* getChatAgents() {
  yield takeEvery(GET_CHAT_AGENTS, function* (action) {
    try {
      const res = yield ApiService.get("/hulk/api/v1/bot-agents");
      if (res && res.status == "success") {
        yield put(saveChatAgents(res.data));
      }
    } catch (err) {
      toastNotification({ errorMessage: "Internal Server Error" });
    }
  });
}

function* getChatGroups() {
  yield takeEvery(GET_CHAT_GROUPS, function* (action) {
    try {
      const res = yield ApiService.get("/hulk/api/v1/user-teams-inbox");

      if (res && res.status == "success") {
        yield put(saveChatGroups(res.data));
      }
    } catch (err) {
      toastNotification({ errorMessage: "Internal Server Error" });
    }
  });
}

function* sendChatAssignmentRules() {
  yield takeEvery(SEND_CHAT_ASSIGNMENT_RULES, function* (action) {
    try {
      yield ApiService.post(
        "/hulk/api/v1/chat-assignments",
        {},
        action.payload
      );

      yield put(getAllChatAssignmentRulesAction());

      toastNotification({ successMessage: "Rule created successfully" });
    } catch (error) {
      toastNotification({ errorMessage: "Internal Server Error" });
    }
  });
}

function* updateChatAssignmentRules() {
  yield takeEvery(UPDATE_CHAT_ASSIGNMENT_RULES, function* (action) {
    const { id: chatAssignmentId, rules: chatAssignmentRules } = action.payload;
    console.log("updateChatAssignmentRules", action.payload);

    try {
      yield ApiService.put(
        `/hulk/api/v1/chat-assignments/${chatAssignmentId}`,
        {},
        chatAssignmentRules
      );

      yield put(getAllChatAssignmentRulesAction());

      toastNotification({ successMessage: "Rule updated successfully" });
    } catch (error) {
      toastNotification({ errorMessage: "Internal Server Error" });
    }
  });
}

function* updateChatAssignmentRuleStatus() {
  yield takeEvery(UPDATE_CHAT_ASSIGNMENT_RULE_STATUS, function* (action) {
    const { id: chatAssignmentId, rules: chatAssignmentRules } = action.payload;

    try {
      yield ApiService.put(
        `/hulk/api/v1/chat-assignments/${chatAssignmentId}`,
        {},
        chatAssignmentRules
      );

      yield put(getAllChatAssignmentRulesAction());

      toastNotification({
        successMessage: "Rule status updated successfully",
      });
    } catch (error) {
      toastNotification({ errorMessage: "Internal Server Error" });
    }
  });
}

function* getAllChatAssignmentRules() {
  yield takeEvery(GET_ALL_CHAT_ASSIGNMENT_RULES, function* (action) {
    try {
      const res = yield ApiService.get(`/hulk/api/v1/chat-assignments`, {}, {});

      yield put(saveAllChatAssignmentRules(res.data));
    } catch (error) {
      toastNotification({ errorMessage: "Internal Server Error" });
    }
  });
}

function* deleteChatAssignmentRule() {
  yield takeEvery(DELETE_CHAT_ASSIGNMENT_RULE, function* (action) {
    try {
      yield ApiService.delete(
        `/hulk/api/v1/chat-assignments/${action.payload}`
      );

      yield put(getAllChatAssignmentRulesAction());

      toastNotification({ successMessage: "Rule deleted successfully" });
    } catch (error) {
      toastNotification({ errorMessage: "Internal Server Error" });
    }
  });
}

export default function* rootSaga() {
  yield all([
    getChatAgents(),
    getChatGroups(),
    sendChatAssignmentRules(),
    getAllChatAssignmentRules(),
    updateChatAssignmentRules(),
    deleteChatAssignmentRule(),
    updateChatAssignmentRuleStatus(),
  ]);
}
